/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  AddressRequest,
  AddressResponse,
  CreateOrganisationShippingAddressParams,
  UpdateOrganisationShippingAddressParams,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiAddressController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-address-controller
   * @name GetPersonalAddress
   * @request GET:/api/v1/user-profile/address
   */
  getPersonalAddress = (params: RequestParams = {}) =>
    this.http.request<AddressResponse, any>({
      path: `/v1/user-profile/address`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getPersonalAddressPath = '/v1/user-profile/address'
  static getPersonalAddressMethod = 'GET'
  /**
   * No description
   *
   * @tags api-address-controller
   * @name UpdatePersonalAddress
   * @request PUT:/api/v1/user-profile/address
   */
  updatePersonalAddress = (data: AddressRequest, params: RequestParams = {}) =>
    this.http.request<AddressResponse, any>({
      path: `/v1/user-profile/address`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updatePersonalAddressPath = '/v1/user-profile/address'
  static updatePersonalAddressMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-address-controller
   * @name CreatePersonalAddress
   * @request POST:/api/v1/user-profile/address
   */
  createPersonalAddress = (data: AddressRequest, params: RequestParams = {}) =>
    this.http.request<AddressResponse, any>({
      path: `/v1/user-profile/address`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createPersonalAddressPath = '/v1/user-profile/address'
  static createPersonalAddressMethod = 'POST'
  /**
   * No description
   *
   * @tags api-address-controller
   * @name UpdateOrganisationShippingAddress
   * @request PUT:/api/v1/organisation/shipping-address
   */
  updateOrganisationShippingAddress = (
    query: UpdateOrganisationShippingAddressParams,
    data: AddressRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<AddressResponse, any>({
      path: `/v1/organisation/shipping-address`,
      method: 'PUT',
      query: query,
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateOrganisationShippingAddressPath = '/v1/organisation/shipping-address'
  static updateOrganisationShippingAddressMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-address-controller
   * @name CreateOrganisationShippingAddress
   * @request POST:/api/v1/organisation/shipping-address
   */
  createOrganisationShippingAddress = (
    query: CreateOrganisationShippingAddressParams,
    data: AddressRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<AddressResponse, any>({
      path: `/v1/organisation/shipping-address`,
      method: 'POST',
      query: query,
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createOrganisationShippingAddressPath = '/v1/organisation/shipping-address'
  static createOrganisationShippingAddressMethod = 'POST'
  /**
   * No description
   *
   * @tags api-address-controller
   * @name UpdateOrganisationAddress
   * @request PUT:/api/v1/organisation/address
   */
  updateOrganisationAddress = (data: AddressRequest, params: RequestParams = {}) =>
    this.http.request<AddressResponse, any>({
      path: `/v1/organisation/address`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateOrganisationAddressPath = '/v1/organisation/address'
  static updateOrganisationAddressMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-address-controller
   * @name CreateOrganisationAddress
   * @request POST:/api/v1/organisation/address
   */
  createOrganisationAddress = (data: AddressRequest, params: RequestParams = {}) =>
    this.http.request<AddressResponse, any>({
      path: `/v1/organisation/address`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createOrganisationAddressPath = '/v1/organisation/address'
  static createOrganisationAddressMethod = 'POST'
  /**
   * No description
   *
   * @tags api-address-controller
   * @name DeleteAddressForUser
   * @request DELETE:/api/v1/user/addresses/{addressType}
   */
  deleteAddressForUser = (addressType: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/user/addresses/${addressType}`,
      method: 'DELETE',
      ...params,
    })

  static deleteAddressForUserPath = '/v1/user/addresses/${addressType}'
  static deleteAddressForUserMethod = 'DELETE'
}
